import { MenuItem } from '../models/sidebar';
import logo from '../assets/images/bebrave-logo.svg';

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    name: 'DASHBOARD',
    path: '/dashboard',
    icon: 'LayoutDashboard',
  },
  {
    id: 'eaglegpt',
    name: 'EAGLEGPT_TITLE',
    path: '/chat',
    icon: 'MessageCircle',
    imageIcon: logo,
    isIntegrated: true,
  },
  {
    id: 'apps',
    name: 'APPS',
    path: '/home',
    icon: 'LayoutDashboard',
    isIntegrated: true,
  },
  {
    id: 'chat',
    name: 'CHAT',
    path: '/chat',
    icon: 'MessageCircle',
  },
];
